import * as React from "react";

import "./corporate-billing-accounts.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Load2}          from "@Common/react/load2";
import {scn, scnv}      from "@Common/react/state-change-nested-value";
import {UseState}       from "@Common/react/use-state";
import {SliderCheckbox} from "@Common/ui-components/slider-checkbox/slider-checkbox";
import {cnv}            from "@Common/utils/arr-path";
import {chain}          from "@Common/utils/fs";
import {equalDeep}      from "@Common/utils/objects";

import {CorporateBillingAccountsBase} from "@Xpresso/routes/common/heavy/corporate-billing-accounts/corporate-billing-accounts-base";

export const CorporateBillingAccounts = ({initEnrollment, program, next}) => cs(
    consumeContext("apis"),
    consumeContext("session"),
    ["billingAccounts", ({apis, session}, next) => {
        // console.log("session", session);
        const params = {
            idProgram: program?.idProgram,
            idBranch: session.value?.branchId,
            idAgent: session.value?.agentId,
            idRegion: session.data?.region?.idRegion ?? session.data?.branch?.idRegion,
        };
        // console.log("params", params);
        return Load2({
            _key: JSON.stringify([session.loading, params]),
            fetch: () => session.loading ? null : apis.next.billing.getBillingAccounts(params),
            next,
        });
    }],
    ["appliedBillings", (_, next) => UseState({
        getInitValue: () => chain(
            initEnrollment?.payment_options?.billingAccount,
            (_) => ({
                current: _,
                saved  : _,
            }),
        ),
        next,
    })],
    ["base", ({billingAccounts, appliedBillings}, next) => CorporateBillingAccountsBase({
        billingAccounts: billingAccounts.value?.map((billingAccount) => ({billingAccount: {id: billingAccount.idAccount, name: billingAccount.accountName}})),
        appliedBillings: appliedBillings.value.current?.map((b) => ({
            billingId: b.id,
        })),
        addBilling: async ({billingId, fields}) => {
            scnv(appliedBillings, ["current"], () => [{
                id: billingId,
            }]);
        },
        updateBilling: async ({billingId, fields}) => {
            scnv(appliedBillings, ["current"], () => [{
                id: billingId,
            }]);
        },
        removeBilling: async () => {
            scnv(appliedBillings, ["current"], () => null);
        },
        next,
    })],
    ({base, appliedBillings, billingAccounts}) => next({
        enrollmentEditor: {
            valid: true,

            loading: billingAccounts.loading,

            $name: "Billing Accounts",
            prepareSave: (enrollment) => ({
                newValue: cnv(enrollment, ["payment_options", "billingAccount"], (_) => appliedBillings.value.current),
                onSaved: () => scn(appliedBillings, ["saved"], () => appliedBillings.value.current),
            }),
            changed: !equalDeep(appliedBillings.value.current, appliedBillings.value.saved),
        },
        selected: appliedBillings.value.current?.length > 0,
        render: () => (
            <div {...{
                className: "corporate-billing-accounts-5wk",

                "xd-qa-type": "card",
                "xd-qa-name": "Corporate Billing Accounts",
            }}>
                <div className="header">
                    <div className="left">
                        <div {...{
                            className: "title",
                            "xd-qa-type": "label",
                            "xd-qa-name": "Corporate Billing Title",
                        }}>
                            Billing Accounts
                        </div>
                    </div>

                    {SliderCheckbox({
                        ...base.masterToggle,
                        xdQaName: "Corporate Billing Accounts",
                    })}
                </div>

                <div className="content">
                    {base.renderList({showErrors: false, apiErrors: null, asRadioButtons: true})}
                </div>
            </div>
        ),
    }),
);
